// Copy for the "Gen AI Strategy: Talk to Your Data" section
// (src/components/solutions/GenAIStrategySection.tsx — used on RAS, Integrated Retail Master Data Model, Retail Data Workshop).
// Tabs are in the same order as TABS in the component (context-aware, actionable, chatbot, mcp).

const en = {
  headingPrefix: 'Gen AI Strategy:',
  headingAccent: 'Talk to Your Data',
  subtitle: 'Interfaces that connect Large Language Models (LLMs) directly to your unified data model.',
  tabs: [
    {
      title: 'Context-Aware AI Agents',
      description: 'We create a "business glossary" that defines your metrics and context. When you ask an AI question, it understands your specific business logic.',
    },
    {
      title: 'Actionable Insights',
      description: 'Instead of just reading a chart, you can ask: "What are the current constraints holding me back from my North Star?" or "If I lower the price on this category, how will it affect my Net Profit?".',
    },
    {
      title: 'In-app chatbot',
      description: 'Use RAS AI Chatbot to talk to your dataset. This chatbot has predefined context which sets clear boundaries of understanding of the data to provide better accuracy of insights.',
    },
    {
      title: 'Connections via MCP',
      description: 'Use RAS MCP to bring the data to your favorite AI interface. Currently supported are Claude, Cursor, MS Copilot in Teams.',
    },
  ],
};

const sk: typeof en = {
  headingPrefix: 'Gen AI stratégia:',
  headingAccent: 'Rozprávajte sa so svojimi dátami',
  subtitle: 'Rozhrania, ktoré napoja veľké jazykové modely (LLM) priamo na váš jednotný dátový model.',
  tabs: [
    {
      title: 'AI agenti, ktorí poznajú kontext',
      description: 'Vytvoríme „biznis slovník“, ktorý definuje vaše metriky a kontext. Keď sa AI na niečo spýtate, rozumie logike práve vášho biznisu.',
    },
    {
      title: 'Poznatky, podľa ktorých sa dá konať',
      description: 'Namiesto čítania grafov sa môžete rovno spýtať: „Čo mi momentálne bráni dosiahnuť moju North Star metriku?“ alebo „Ako sa prejaví na čistom zisku, ak v tejto kategórii znížim ceny?“',
    },
    {
      title: 'Chatbot priamo v aplikácii',
      description: 'S RAS AI chatbotom sa môžete rozprávať so svojimi dátami. Chatbot má vopred nastavený kontext, ktorý jasne vymedzuje, ako dátam rozumie. Vďaka tomu sú odpovede presnejšie.',
    },
    {
      title: 'Napojenie cez MCP',
      description: 'Cez RAS MCP dostanete dáta do svojho obľúbeného AI nástroja. Aktuálne podporujeme Claude, Cursor a MS Copilot v Teams.',
    },
  ],
};

export const genAiStrategyCopy = { en, sk };
